export type MagicLinkRequest = {
  email: string;
  options: {
    emailRedirectTo: string;
    shouldCreateUser: false;
  };
};

/** Keep passwordless sign-in on the exact browser origin that requested it. */
export const magicLinkRequest = (email: string, browserOrigin: string): MagicLinkRequest => ({
  email,
  options: {
    emailRedirectTo: browserOrigin,
    shouldCreateUser: false,
  },
});
